<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Listado de clientes/prospectos</custom-title>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconAdd"
        @click="openModal"
        >Nuevo cliente/prospecto</el-button
      >
      <modal-new-prospect
        v-model="modalVisible"
        @closed="handleModalClosed"
      ></modal-new-prospect>
    </template>
  </main-buttons-bar>
  <prospect-filters></prospect-filters>
  <custom-table
    :requestApi="findAllProspectsHTTP"
    :pathDetail="'/page/prospects/detail'"
    :pathEdit="'/page/prospects/edit'"
    :paramId="'Codigo'"
    :data="prospects"
    :columns="columns"
    :firstLoad="false"
  ></custom-table>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useProspectStore } from './../stores/prospect_store';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTable from '@/shared/components/custom_table.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import IconAdd from '~icons/mdi/add';
import ModalNewProspect from '@/shared/components/modal_new_prospect.vue';
import ProspectFilters from './prospect_filters.vue';

const prospectStore = useProspectStore();
const { resetFilter, emptyList, firstProspects, findAllProspectsHTTP, hideNewModal } =
  prospectStore;
const { prospects, isNewModalOpen } = storeToRefs(prospectStore);

// local state
const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];

const columns = [
  { field: 'Codigo', label: 'Código', width: 100, sortable: true, isVisible: true },
  {
    field: 'CodigoSecundario',
    label: 'Codigo Adicional',
    width: 230,
    sortable: true,
    isVisible: true,
  },
  { field: 'Descripcion', label: 'Descripcion', width: 580, sortable: true, isVisible: true },
  { field: 'Giro', label: 'Giro', width: 200, sortable: true, isVisible: true },
  { field: 'Activo', label: 'Activo', width: 120, sortable: true, isVisible: true },
];
const modalVisible = ref(isNewModalOpen);

const openModal = () => {
  modalVisible.value = true;
};

const handleModalClosed = () => {
  // Acciones a realizar cuando se cierra el modal
  modalVisible.value = false;
  hideNewModal();
};

onBeforeMount(async () => {
  resetFilter();
  emptyList();
  firstProspects();
});
</script>

<style scoped></style>
